import { useDispatch, useSelector } from "react-redux";
import { Modal } from "components";
import { icons } from "utils/constants";
import { setShowSubscriptionExpirePopup } from "store/globalSlice";
import "./SubscriptionExpirePopup.scss";

const SubscriptionExpirePopup = () => {
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.global);
  const {
    showSubscriptionExpirePopup,
    isDarkMode,
    remainingDays,
    isSubscription,
  } = reduxData || {};
  let subEndMinute = localStorage.getItem("subscriptionEndMinute");
  const convertMinsToHrsMins = (mins) => {
    let h = Math.floor(mins / 60);
    let m = Math.round(mins % 60);
    return `${h > 0 ? `${h} hour${h > 1 ? "s" : ""} ` : ""}${m} minute${
      m > 1 ? "s" : ""
    }`;
  };
  return (
    <>
      {showSubscriptionExpirePopup && isSubscription && (
        <Modal
          width="400px"
          title="Subscription Status"
          onHide={() => {
            dispatch(setShowSubscriptionExpirePopup(false));
          }}
          isDarkMode={isDarkMode}
        >
          <div className="cps-26 cpe-26 cpt-26 cmb-10">
            <div className="h-175 cmb-40">
              <img
                src={
                  isDarkMode
                    ? icons.cancelSubscriptionLight
                    : icons.cancelSubscription
                }
                alt="purSub"
                className="fit-image"
              />
            </div>
            <div
              className={`text-center text-18-600 cmb-40 ${
                remainingDays <= 7 ? "color-4639" : "color-4639"
              }`}
            >
              {remainingDays <= 0 && subEndMinute < 1
                ? "Subscription expired"
                : `Subscription due in ${
                    remainingDays > 0
                      ? `${remainingDays} days`
                      : convertMinsToHrsMins(subEndMinute)
                  }`}
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default SubscriptionExpirePopup;
